import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../services/bloqueo-modulo.service";
import * as i2 from "@angular/router";
import * as i3 from "../services/console.service";
export class BloqueoVistaGuard {
    constructor(bloqueoVistaService, router, clog) {
        this.bloqueoVistaService = bloqueoVistaService;
        this.router = router;
        this.clog = clog;
        this.bloqueoVistaErrorComponent = 'bloqueo-vista-error';
        this.log = this.clog.log('BLOQUEO-VISTA-GUARD');
    }
    canActivate(next, state) {
        const codigoModulo = next.data['codigo_modulo'];
        if (!codigoModulo) {
            this.log('El módulo no se especificó en la ruta.');
            return true;
        }
        return this.bloqueoVistaService.verificarBloqueoModulo(codigoModulo).pipe(switchMap((response) => {
            if (!response.exito) {
                return of(true);
            }
            return this.bloqueoVistaService.adquirirBloqueo(codigoModulo).pipe(map((response) => {
                if (response.exito) {
                    this.log('BLOQUEO ADQUIRIDO', response);
                    return true;
                }
                else {
                    this.log('BLOQUEO NO ADQUIRIDO', response);
                    // SI NO ES EXITOSO, SE DEBE REDIRIGIR AL COMPONENTE ERROR
                    // QUE MUESTRE EL ERROR Y ENVIANDO EL RESPONSE
                    return this.router.createUrlTree([this.bloqueoVistaErrorComponent], { state: { bloqueo: response } });
                }
                this.log('BLOQUEO NO ADQUIRIDO', response);
                // SI NO ES EXITOSO, SE DEBE REDIRIGIR AL COMPONENTE ERROR
                // QUE MUESTRE EL ERROR Y ENVIANDO EL RESPONSE
                return this.router.createUrlTree([this.bloqueoVistaErrorComponent], { state: { bloqueo: response } });
            }), catchError((error) => {
                this.log('Error al adquirir el bloqueo:', error);
                return of(this.router.createUrlTree([this.bloqueoVistaErrorComponent]));
            }));
        }), 
        // Captura errores de verificarBloqueoModulo y de la cadena completa
        catchError((error) => {
            this.log('Error al verificar el bloqueo del módulo:', error);
            return of(this.router.createUrlTree([this.bloqueoVistaErrorComponent]));
        }));
    }
    canDeactivate(component, currentRoute, currentState, nextState) {
        const codigoModulo = currentRoute.data['codigo_modulo'];
        if (!codigoModulo) {
            this.log('No se pudo determinar el codigoModulo para liberar el bloqueo al desactivar.');
            return true; // Permitir salir si no podemos determinar el módulo
        }
        // SOLO VAMOS A LIBERAR CUANDO EL MODULO ACTUAL ES EL QUE ESTA
        // REGISTRADO EN EL SERVICIO
        if (this.bloqueoVistaService.getCodigoModuloBloqueado() === codigoModulo) {
            return this.bloqueoVistaService.liberarBloqueo(codigoModulo).pipe(map((response) => {
                if (!response.exito) {
                    this.log(`Falló la liberación del bloqueo para el módulo ${codigoModulo}: ${response.mensajeError}`);
                }
                // Permitir la desactivación, incluso si la liberación falla (para no bloquear al usuario en la vista)
                return true;
            }), catchError(() => {
                this.log(`Error de comunicación al liberar el bloqueo para el módulo ${codigoModulo}.`);
                return of(true); // Permitir la desactivación, incluso si hay un error en la solicitud
            }));
        }
        else {
            this.log(`El módulo ${codigoModulo} no coincide con el módulo bloqueado actual ${this.bloqueoVistaService.getCodigoModuloBloqueado()}`);
            return true;
        }
    }
}
BloqueoVistaGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BloqueoVistaGuard_Factory() { return new BloqueoVistaGuard(i0.ɵɵinject(i1.BloqueoModuloService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.ConsoleService)); }, token: BloqueoVistaGuard, providedIn: "root" });
